import type { OnSiteAppointment } from '../../api/analytics.ts'

// Helper function to format date time
export const getAppropriateTime = (
  appointment: OnSiteAppointment,
  timeColumn: string
): string | null => {
  switch (timeColumn) {
    case 'scheduleStartTime':
      return appointment.scheduleStartTime
      break
    case 'confirmationEmailSent':
      return appointment.confirmationEmailSent
      break
    case 'createdAt':
      return appointment.createdAt
      break
    case 'updatedAt':
      return appointment.updatedAt
      break
    case 'statusChangedAt':
      return appointment.statusChangedAt
      break
    default:
      return appointment.scheduleStartTime
  }
}
